var map = {
	"./sifi_fk/config": "./src/assets/env/sifi_fk/config.json",
	"./sifi_fk/config.json": "./src/assets/env/sifi_fk/config.json",
	"./sifi_fk/config_chart": "./src/assets/env/sifi_fk/config_chart.json",
	"./sifi_fk/config_chart.json": "./src/assets/env/sifi_fk/config_chart.json",
	"./sifi_fk/env.scss": "./src/assets/env/sifi_fk/env.scss",
	"./sifi_fk/images/bg-element.svg": "./src/assets/env/sifi_fk/images/bg-element.svg",
	"./sifi_fk/images/favicon.svg": "./src/assets/env/sifi_fk/images/favicon.svg",
	"./sifi_fk/images/logo-dark.svg": "./src/assets/env/sifi_fk/images/logo-dark.svg",
	"./sifi_fk/images/logo-prelogin.svg": "./src/assets/env/sifi_fk/images/logo-prelogin.svg",
	"./sifi_fk/images/logo.svg": "./src/assets/env/sifi_fk/images/logo.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/env sync recursive ^\\.\\/sifi_fk.*$";